import {
  ConnectedMcpAppRO,
  McpUsageHistoryRO,
  McpUsageSummaryRO,
} from "@intentsify/dto";
import { apiService, Endpoints } from "api";

const listConnectedMcpApps = async (): Promise<ConnectedMcpAppRO[]> => {
  const { data } = await apiService.get<ConnectedMcpAppRO[]>(
    Endpoints.OAuth.ConnectedApps.Get,
  );
  return data;
};

const revokeConnectedMcpApp = async (grantId: string): Promise<void> => {
  await apiService.delete(Endpoints.OAuth.ConnectedApps.Delete(grantId));
};

const getMcpUsageSummary = async (): Promise<McpUsageSummaryRO> => {
  const { data } = await apiService.get<McpUsageSummaryRO>(
    Endpoints.OAuth.ConnectedApps.Usage,
  );
  return data;
};

const getMcpUsageHistory = async (): Promise<McpUsageHistoryRO> => {
  const { data } = await apiService.get<McpUsageHistoryRO>(
    Endpoints.OAuth.ConnectedApps.UsageHistory,
  );
  return data;
};

export {
  getMcpUsageHistory,
  getMcpUsageSummary,
  listConnectedMcpApps,
  revokeConnectedMcpApp,
};
